// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1knUs","footer":"Form_footer__YC80S"};